import TimeActivityCollection from './TimeActivityCollection';

export default class CalendarEventTimeActivityCollection extends TimeActivityCollection
{

    constructor(items, calendarEvent)
    {
        super(items.map(item => {
            item.calendar_events_ids = [calendarEvent.id];
            return item;
        }));

        this.calendarEvent = calendarEvent;
        window.App.$bus.$on(`planning:time-activity:updated`, (item) => this.update(item));
    }

    destroy()
    {
        super.destroy();
        window.App.$bus.$off(`planning:time-activity:updated`, (item) => this.update(item));
    }

    itemShouldBeInCollection(activity)
    {
        return activity.calendar_events_ids && activity.calendar_events_ids.includes(this.calendarEvent.id);
    }

    update(activity)
    {
        if ( this.itemShouldBeInCollection(activity) && !this.items.some(i => i.uuid == activity.uuid) ) {
            this.add(activity);
        }
    }

}